import { DraftMentionFormatterType } from '../../interface/draft/draft-mention-formatter.type';
import { printValue } from './print-value.util';
import { findLinkedData } from '../page/find-linked-data.util';
import { LinkedDataModel } from '../../model/linked-data/linked-data.model';
import { AppStateModel } from '../../model/app-state.model';
import { DesignObjectMentionMetadataType } from '../../enum/page-mention-metadata-type.enum';
import * as moment from 'moment';
import { formatMoney } from '../number/format-money.util';
import {getHtmlDraftFont} from './get-html-draft-font.util';

const getUnknown = (foundData: LinkedDataModel, inEditor) => {
  return (inEditor ? `@${foundData.displayName}` : '');
};
const fontMap = {
  Georgia: '\'Georgia\', serif',
  Impact: '\'Impact\', \'Charcoal\', sans-serif',
  Tahoma: '\'Tahoma\', \'Geneva\', sans-serif',
  ['Times New Roman']: '\'Times New Roman\', Times, serif',
  Verdana: '\'Verdana\', \'Geneva\', sans-serif',
  Arial: '\'Arial\', \'Helvetica\', sans-serif'
};

export const renderDraftToHTML = (state: AppStateModel, formatter: DraftMentionFormatterType, inEditor: boolean, blockMentionData: { [key: string]: any } = {}) => (entity, htmlText: string) => {
  let newHTML = htmlText;
  const htmlDraftFont = getHtmlDraftFont(newHTML);
  if (entity.type === 'MENTION') {
    let data;
    if (!state.activeDesign.data.linkedData) {
      console.warn('Can`t find linked data for used mention', JSON.stringify(entity.data));
    } else {
      const foundData = findLinkedData(entity.data, state.activeDesign.data, blockMentionData);
      if (!foundData) {
        console.warn('Can`t find linked data for used mention', JSON.stringify(entity.data));
      } else {
        const isHTML = foundData.type === DesignObjectMentionMetadataType.Html;
        const wrapperElement = isHTML ? 'div' : 'span';
        const currentDataFormatter: DraftMentionFormatterType = Object.assign({}, formatter);
        if (entity.data.format) {
          if (entity.data.format[DesignObjectMentionMetadataType.Date]) {
            currentDataFormatter[DesignObjectMentionMetadataType.Date] = (value: string) => {
              return moment(value).format(entity.data.format[DesignObjectMentionMetadataType.Date]);
            };
          }
          if (entity.data.format[DesignObjectMentionMetadataType.Text]) {
            const oldFormatter = currentDataFormatter[DesignObjectMentionMetadataType.Text];
            currentDataFormatter[DesignObjectMentionMetadataType.Text] = (value: string, appState) => {
              if (!isNaN(Number(value))) {
                switch (entity.data.format[DesignObjectMentionMetadataType.Text]) {
                  case 'integer':
                    return String(parseInt(value, 10));
                  case 'decimal':
                    return Number(value).toFixed(2);
                  case 'currency':
                    return formatMoney(value);
                }
              }
              return oldFormatter ? oldFormatter(value, appState) : value;
            };
          }
        }
        const fontStyle = htmlDraftFont ? `style="font-family: ${htmlDraftFont};"` : '';
        const toReturn = foundData.data !== null && foundData.data !== undefined ?
          `<${wrapperElement} ${fontStyle} data-mention="${foundData.displayName}" data-value="${foundData.mentionId}">${printValue(state, foundData, currentDataFormatter, blockMentionData)}</${wrapperElement}>` :
          getUnknown(foundData, inEditor);
        data = htmlText;
        if (isHTML) {
          if (data === undefined) {
            data = ' ';
          }
          data = data.replace(/<span/g, '<div').replace(/<\/span>/g, '</div>');
        }
        data = data.replace(entity.data.displayName, toReturn);
      }
    }
    newHTML = data ? data : ' ';
  }
  if (entity.type === 'LINK') {
    const targetOption = entity.data.targetOption || '_self';
    newHTML = '<a href="' + entity.data.url + '" target="' + targetOption + '">' + newHTML + '</a>';
  }
  if (entity.type === 'IMAGE') {
    newHTML = '<img src="' + entity.data.src + '" alt="' + entity.data.alt + '" style="float:' + (entity.data.alignment || 'none') + ';height: ' + entity.data.height + ';width: ' + entity.data.width + '"/>';
  }
  if (entity.type === 'EMBEDDED_LINK') {
    newHTML = '<iframe width="' + entity.data.width + '" height="' + entity.data.height + '" src="' + entity.data.src + '" frameBorder="0"></iframe>';
  }
  Object.keys(fontMap).forEach((key) => {
    const lookup = new RegExp(`font-family: ${key};`, 'g');
    const replaceValue = `font-family: ${fontMap[key]};`;
    newHTML = newHTML.replace(lookup, replaceValue);
  });
  return newHTML;
};
